import { useSelector } from "react-redux";
import { Container, AuthModal, Login, Signup } from "../../Components";

function Unauthenticated() {
  const { showLogIn, showSignUp } = useSelector((state) => state.ui);
  return (
    <Container>
      <div className="flex mt-12   flex-col-reverse md:flex-row justify-around">
        <div className=" w-full mt-5 md:w-2/5 	flex 	flex-col	justify-center items-center md:items-start	 	">
          <h1 className="font-semibold	text-5xl my-4	">
            Infinite Creative Possibilities
          </h1>
          {showLogIn || showSignUp ? (
            <p className="text-base	font-light mb-[73px]	">
              A Multimedia Generative Suite for the Modern Creative
            </p>
          ) : (
            <p className="text-base	font-light	">
              Infinite Creative Possibilities A Multimedia Generative Suite for
              the Modern Creative
              <br />
              <br />
              Best in class models for your multimedia needs. Image, Sound,
              Text, and Video. Get Started
            </p>
          )}
          <div className="my-4">
            <button className="rounded font-semibold border-2 border-blue text-white px-10 py-3.5 bg-blue  hover:bg-white hover:text-blue">
              Get Started
            </button>
          </div>
        </div>
        {showLogIn || showSignUp ? (
          /*
           *For Log In/Sign Up
           */
          <>
            {showLogIn && (
              <AuthModal filled>
                <Login />
              </AuthModal>
            )}
            {showSignUp && (
              <AuthModal outlined>
                <Signup />
              </AuthModal>
            )}
          </>
        ) : (
          <div className="md:ml-7">
            <img className="h-full" src="/banner.svg" alt="banner" />
          </div>
        )}
      </div>
    </Container>
  );
}

export default Unauthenticated;
